// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gate-score-arrow {
    height: 150px;
}

.gate-score-next-gate {
    font-weight: 700;
}

.gate-countdown-timer {
    color: black;
    margin-top: 7px;
}

.gate-remaining-seconds {
    text-align: center;
    font-size: x-large;
}

.gate-remaining-seconds-red {
    color: #e50000;
}

.gate-countdown-label {
    font-size: 8px;
    width: 100vw;
}

.click-time-arrow {
    position: relative;
    width: 28px;
    margin-left: 2px;
}
.time-text {
    transform: rotate(-90deg);
    position: absolute;
    top: 47px;
    left: 7px;
    color: #e2f0d9;
}

.danger-level-gauge {
    position: absolute;
    right: 32px;
    bottom: 69px;
}

.gate-estimated-crossing-offset {
    text-align: center;
    font-size: medium;
}

.gate-score-arrow {
    /*bottom: 2px;*/
    /*left: 145px;*/
    /*position: fixed;*/
    /*width: 530px;*/
    /*height: 110px;*/
    z-index: 2;
    margin-bottom: -38px;
}

.gate-arrow-canvas {
    margin-top: -42px;
}

.gate-arrow-shadow {
    box-shadow: 5px 10px 5px rgba(0, 0, 0, 0.6);
    border-radius: 15px 15px 0 0;
    height: 80px;
    width: 512px;
    background: #f8f4f0;
    color: #92d468;
    border: solid;
}
`, "",{"version":3,"sources":["webpack://./reactjs/components/gateScoreArrow/gateScore.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,4BAA4B;IAC5B,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,aAAa;AACjB","sourcesContent":[".gate-score-arrow {\n    height: 150px;\n}\n\n.gate-score-next-gate {\n    font-weight: 700;\n}\n\n.gate-countdown-timer {\n    color: black;\n    margin-top: 7px;\n}\n\n.gate-remaining-seconds {\n    text-align: center;\n    font-size: x-large;\n}\n\n.gate-remaining-seconds-red {\n    color: #e50000;\n}\n\n.gate-countdown-label {\n    font-size: 8px;\n    width: 100vw;\n}\n\n.click-time-arrow {\n    position: relative;\n    width: 28px;\n    margin-left: 2px;\n}\n.time-text {\n    transform: rotate(-90deg);\n    position: absolute;\n    top: 47px;\n    left: 7px;\n    color: #e2f0d9;\n}\n\n.danger-level-gauge {\n    position: absolute;\n    right: 32px;\n    bottom: 69px;\n}\n\n.gate-estimated-crossing-offset {\n    text-align: center;\n    font-size: medium;\n}\n\n.gate-score-arrow {\n    /*bottom: 2px;*/\n    /*left: 145px;*/\n    /*position: fixed;*/\n    /*width: 530px;*/\n    /*height: 110px;*/\n    z-index: 2;\n    margin-bottom: -38px;\n}\n\n.gate-arrow-canvas {\n    margin-top: -42px;\n}\n\n.gate-arrow-shadow {\n    box-shadow: 5px 10px 5px rgba(0, 0, 0, 0.6);\n    border-radius: 15px 15px 0 0;\n    height: 80px;\n    width: 512px;\n    background: #f8f4f0;\n    color: #92d468;\n    border: solid;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
